import { Component, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'aqualia-dialogConfirmExit',
  templateUrl: './dialogConfirmExit.component.html',
  styleUrls: ['./dialogConfirmExit.component.css']
})
export class DialogConfirmExitComponent{

  onAdd = new EventEmitter();

  constructor(public dialog: MatDialog) {}

  confirm(result){
    this.onAdd.emit(result);
    this.dialog.closeAll();
  }

}